/**
 * Ramène une erreur d'appel API à la forme que les formulaires attendent déjà :
 * l'objet `errors` tel que l'API le renvoie (`{ champ: { errors: [...] } }`).
 *
 * AD-104 : tant que `validateStatus` acceptait les 400, les modules lisaient
 * `response.data.errors` dans le `.then()` et rejetaient cet objet. Depuis que
 * les 400 sont rejetés, l'appelant reçoit un `AxiosError` — on en ressort le
 * même objet, pour que les pages continuent d'afficher les mêmes messages.
 *
 * @param {*} error rejet manuel d'un `.then()` (déjà à la bonne forme) ou AxiosError
 * @returns {Object} l'objet d'erreurs de formulaire, `{}` si l'API n'en fournit pas
 */
export function toFormErrors(error) {
  if (error && !error.isAxiosError) {
    return error
  }

  return (error.response && error.response.data && error.response.data.errors) || {}
}
